import React, { useState, useRef } from 'react'
import { Icon } from '@iconify/react'
export default function CustomDate({ title, setDay }) {
  const [selectedDate, setSelectedDate] = useState('')
  const dateInputRef = useRef(null)

  const handleDateChange = (event) => {
    const date = event.target.value
    setSelectedDate(date)
    setDay(formatDate(date))
  }

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const [year, month, day] = dateString.split('-')
    return `${day}/${month}/${year}`
  }

  const handleTextClick = () => {
    dateInputRef.current.showPicker()
  }

  return (
    <div className="relative flex items-center gap-3">
      <span>{title}</span>
      <div 
        onClick={handleTextClick}
        className="cursor-pointer rounded-lg border border-gray-300 bg-white px-2 py-1 text-gray-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-accent lg-c:px-4 lg-c:py-2"
      >
        {selectedDate ? formatDate(selectedDate) : 'dd/mm/yyyy'}
        <Icon
        icon="ph:calendar-blank-bold"
          className='text-gray-accent text-2xl inline ml-2'
        />
        
      </div>
      <input
        ref={dateInputRef}
        type="date"
        value={selectedDate}
        onChange={handleDateChange}
        className="absolute opacity-0 w-0 h-0 bottom-0"
      />
    </div>
  )
}

